import { useAuth } from "@/contexts/authContext";
import { type NavItem } from "@/types";
import {
  HeartPulse,
  Bell,
  EqualApproximately,
  House,
  Settings,
  UserRoundPen,
  Compass,
  Videotape,
  MessageCircle,
  ShoppingCart,
  Vote,
} from "lucide-react";
import { userAgent } from "next/server";

export const homePage: NavItem = {
  name: "Home",
  to: "/",
  icon: House,
};
export const clipsPage: NavItem = {
  name: "Clips",
  to: "/clips",
  icon: Videotape,
};
export const notificationPage: NavItem = {
  name: "Notification",
  to: "/notification/",
  icon: Bell,
};
export const aboutPage: NavItem = {
  name: "About",
  to: "/about/",
  icon: EqualApproximately,
};
export const support: NavItem = {
  name: "Support",
  to: "/support/",
  icon: HeartPulse,
};
export const explorePage: NavItem = {
  name: "Explore",
  to: "/explore/",
  icon: Compass,
};
export const blogPage: NavItem = {
  name: "Blog",
  to: "/blog/",
};
export const profilePage: NavItem = {
  name: "Profile",
  to: "/profile",
  icon: UserRoundPen,
};
export const loginPage: NavItem = {
  name: "Login",
  to: "/login/",
};
export const signupPage: NavItem = {
  name: "Sign Up",
  to: "/signup/",
};
export const settingsPage: NavItem = {
  name: "Settings",
  to: "/settings",
  icon: Settings,
  toLg: "/settings/my-account",
};
export const chatsPage: NavItem = {
  name: "Messages",
  to: "/chats/",
  icon: MessageCircle,
};
export const marketPlacePage: NavItem = {
  name: "Marketplace",
  to: "/marketplace/",
  icon: ShoppingCart,
};
export const electionCandidatesPage: NavItem = {
  name: "Elections",
  to: "/elections",
  icon: Vote,
};
export const adminPage: NavItem = {
  name: "Admin",
  to: "/admin/",
  icon: UserRoundPen,
};
// Only include election nav item when NOT in production
export const navItems: NavItem[] = [
  homePage,
  explorePage,
  aboutPage,
  support,
  notificationPage,
  profilePage,
  settingsPage,
  marketPlacePage,
  electionCandidatesPage,
];
